import dayjs from 'dayjs';
import './CourierRating.scss';
import React from 'react';
import { CourierDailyRating } from '../../fetch/fetchCourierRating';
import { CourierRatingDetails } from './CourierRatingDetails';

export function CourierRatingOverview({
  courierRating,
}: {
  courierRating?: CourierDailyRating;
}): JSX.Element {
  if (courierRating == null) {
    return (
      <div>
        <p className="rating-info">No rating details for this date</p>
      </div>
    );
  } else {
    return (
      <>
        <CourierRatingDetails
          positiveRatingsCount={courierRating.positiveRatingsCount}
          neutralRatingsCount={courierRating.neutralRatingsCount}
          negativeRatingsCount={courierRating.negativeRatingsCount}
          comments={courierRating.comments}
          startTime={dayjs(courierRating.startTime)}
          endTime={dayjs(courierRating.endTime)}
          deliveriesCount={courierRating.deliveriesCount}
        />
      </>
    );
  }
}
